module.exports = __webpack_public_path__ + "static/media/central.36208a2b.jpg";